export default "__VITE_ASSET__b339269a__"